export type Locale = "en" | "ar";
export const defaultLocale: Locale = "ar";

export const isAllowedLocale = (locale: string): locale is Locale => {
  return ["en", "ar"].includes(locale);
};
